import { useState } from "react";
import { MODULE_API } from "../../../../apis";
import useModuleData from "./useFetchItems";
export default function UseUpdate(
  formData,
  setFormData,
  fetchData,
  formatModuleKey,
  setTableData,
  setLoading
) {
  const [error, setError] = useState(false);

  const updateRecord = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  return { updateRecord, error };
}
